import { render } from "./passport.html?vue&type=template&id=36b2fc52&external"
import script from "./passport.js?vue&type=script&lang=js&external"
export * from "./passport.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__